<template>
  <div ref="menuWrapper">
    <div
      v-if="isFixed"
      :style="{ height: menuHeight + 'px' }"
    />

    <div
      ref="menu"
      class="c-sub-navigation relative z-10 theme"
      :class="[model.theme, { 'is-fixed': isFixed }]"
    >
      <div class="c-sub-navigation--list">
        <ul class="text-center font-normal text-base whitespace-no-wrap overflow-x-auto">
          <li
            v-for="(item, index) in model.items"
            :key="index"
            class="inline-flex mx-4 sm:mx-2"
          >
            <a
              :href="item.url ? item.url : item.anchor"
              :class="{ 'active': activeItem === (item.anchor || item.url) }"
              :target="item.target"
              class="px-2 py-5 relative"
              @click="handleClick($event, item)"
            >
              {{ item.text }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref, onMounted, onUnmounted, nextTick
} from 'vue'
import tracking from '@/helpers/tracking'

export default {
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const menu = ref(null)
    const menuWrapper = ref(null)
    const isFixed = ref(false)
    const menuHeight = ref(0)
    const menuTop = ref(0)
    const activeItem = ref(null)

    const setInitialActiveItem = () => {
      const activeLink = props.model.items.find((item) => item.isActive)
      if (activeLink) {
        activeItem.value = activeLink.anchor || activeLink.url
      }
    }

    const scrollToHash = () => {
      if (window.location.hash) {
        const target = document.querySelector(window.location.hash)
        if (target && menu.value) {
          const offset = menu.value.offsetHeight || 0
          const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          })
          props.model.items.forEach((item) => {
            item.isActive = item.anchor === window.location.hash
          })
          activeItem.value = window.location.hash
        }
      }
    }

    const handleScroll = () => {
      if (!menu.value) return
      const currentScrollY = window.scrollY

      if (menuTop.value === 0) {
        menuTop.value = menu.value.getBoundingClientRect().top + window.scrollY
      }

      isFixed.value = currentScrollY > menuTop.value
    }

    const handleClick = (event, item) => {
      props.model.items.forEach((i) => {
        i.isActive = false
      })

      if (item.anchor && item.anchor.startsWith('#')) {
        event.preventDefault()
        const target = document.querySelector(item.anchor)
        if (target && menu.value) {
          const offset = menu.value.offsetHeight
          const targetPosition = target.getBoundingClientRect().top + window.scrollY - offset

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          })

          activeItem.value = item.anchor
          window.history.pushState(null, '', item.anchor)
        }
      }

      item.isActive = true
      tracking.ribbonMenuItemClick(item.text)
    }

    onMounted(() => {
      setInitialActiveItem()
      nextTick(() => {
        menuHeight.value = menu.value ? menu.value.offsetHeight : 0
        scrollToHash()
      })
      window.addEventListener('scroll', handleScroll)
    })

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
    })

    return {
      menu,
      menuWrapper,
      isFixed,
      menuHeight,
      activeItem,
      handleClick
    }
  }
}
</script>
